import { useTranslation } from 'react-i18next'

export const useGetEventCategories = () => {
  const { t } = useTranslation()

  const eventCategories = Object.freeze([
    {
      value: 'stadium_concert',
      text: t('Simulation.form.eventCategoryOptions.stadium_concert'),
    },
    {
      value: 'ballet_performance',
      text: t('Simulation.form.eventCategoryOptions.ballet_performance'),
    },
    {
      value: 'choral_concert',
      text: t('Simulation.form.eventCategoryOptions.choral_concert'),
    },
    {
      value: 'club_gig',
      text: t('Simulation.form.eventCategoryOptions.club_gig'),
    },
    {
      value: 'electronic_music_festival',
      text: t('Simulation.form.eventCategoryOptions.electronic_music_festival'),
    },
    {
      value: 'film_in_concert',
      text: t('Simulation.form.eventCategoryOptions.film_in_concert'),
    },
    {
      value: 'hip_hop_show',
      text: t('Simulation.form.eventCategoryOptions.hip_hop_show'),
    },
    {
      value: 'music_theater',
      text: t('Simulation.form.eventCategoryOptions.music_theater'),
    },
    {
      value: 'recital',
      text: t('Simulation.form.eventCategoryOptions.recital'),
    },
    {
      value: 'singer_songwriter',
      text: t('Simulation.form.eventCategoryOptions.singer_songwriter'),
    },
    {
      value: 'orchestra_concert',
      text: t('Simulation.form.eventCategoryOptions.orchestra_concert'),
    },
    {
      value: 'world_traditional_music_concert',
      text: t('Simulation.form.eventCategoryOptions.world_traditional_music_concert'),
    },
    {
      value: 'theater_play',
      text: t('Simulation.form.eventCategoryOptions.theater_play'),
    },
    {
      value: 'comedy',
      text: t('Simulation.form.eventCategoryOptions.comedy'),
    },
    {
      value: 'contemporary_dance',
      text: t('Simulation.form.eventCategoryOptions.contemporary_dance'),
    },
    {
      value: 'nightlife_event',
      text: t('Simulation.form.eventCategoryOptions.nightlife_event'),
    },
    {
      value: 'other',
      text: t('Simulation.form.eventCategoryOptions.other'),
    },
    {
      value: 'conference_and_fairs',
      text: t('Simulation.form.eventCategoryOptions.conference_and_fairs'),
    },
    {
      value: 'corporate_events',
      text: t('Simulation.form.eventCategoryOptions.corporate_events'),
    },
    {
      value: 'sports_individual_combat',
      text: t('Simulation.form.eventCategoryOptions.sports_individual_combat'),
    },
    {
      value: 'sports_motorsports',
      text: t('Simulation.form.eventCategoryOptions.sports_motorsports'),
    },
    {
      value: 'sports_team_match',
      text: t('Simulation.form.eventCategoryOptions.sports_team_match'),
    },
    {
      value: 'esports',
      text: t('Simulation.form.eventCategoryOptions.esports'),
    },
  ])

  return [...eventCategories].sort((a, b) => a.text.localeCompare(b.text))
}

export const specialAdCategories = Object.freeze([
  {
    value: 'employment',
    text: 'Employment',
  },
  {
    value: 'housing',
    text: 'Housing',
  },
  {
    value: 'financial',
    text: 'Financial',
  },
  {
    value: 'political',
    text: 'Political',
  },
])
